import styled from 'styled-components'


export const Button = styled.button`
    border: 5px solid silver;
    border-radius: 50px;
    padding: 0.5rem 2rem;
    margin: 0.5rem;
    text-decoration: none;
    color: white;
    background-color: #16311A;
    transition: 0.3s;
    font-size: 1.1em;
    cursor: pointer;
    outline: none;

    &:hover {
        color: gold;
        border-color: gold;
    }
`;

export default Button

